import React from "react"
import BlogListingEvolv from "./BlogListingEvolv"
import BlogListingHead from "./BlogListingHead"
import DynamicBreadcrumb from "../../../components/DynamicBreadcrumb";
import { useEffect, useState } from "react";
import { BaseUrl } from "../../../helper/BaseUrl";

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Blog",
  },
]


export default function BlogListing({ initialData }) {
  const [allData, setAllData] = useState(initialData || []);
  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}api/blogs`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <BlogListingHead breadcrumbData={breadcrumbData} allData={allData} />
      <BlogListingEvolv />
    </>
  )
}